import { render, staticRenderFns } from "./admin-create-lead-steps-cat.vue?vue&type=template&id=639fc28f&scoped=true&"
import script from "./admin-create-lead-steps-cat.vue?vue&type=script&lang=js&"
export * from "./admin-create-lead-steps-cat.vue?vue&type=script&lang=js&"
import style0 from "./admin-create-lead-steps-cat.vue?vue&type=style&index=0&id=639fc28f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639fc28f",
  null
  
)

export default component.exports